export const common = {
  name: "نام",
  title: "عنوان",
  isDeleted: "حذف شده",
  updatedAt: "بروز شده",
  id: "شناسه",
  image: "تصویر",
  type: "نوع",
};
export default {
  ra: {
    action: {
      add_filter: "اضافه‌کردن فیلتر",
      add: "اضافه",
      back: "بازگشت",
      bulk_actions:
        "۱ آیتم انتخاب شد |||| %{smart_count} عدد از آیتم‌ها انتخاب شدند",
      cancel: "انصراف",
      clear_input_value: "پاک‌کردن مقدار",
      clone: "شبیه‌سازی",
      confirm: "تایید",
      create: "ایجاد",
      delete: "حذف",
      edit: "ویرایش",
      export: "دریافت خروجی",
      list: "لیست",
      refresh: "بروز‌رسانی",
      remove_filter: "حذف این فیلتر",
      remove: "حذف",
      save: "ذخیره",
      save_and_show: "ذخیره و نمایش",
      save_and_add: "ذخیره و افزودن",
      back_to_list: "بازگشت به لیست",
      restore: "بازگردانی",
      search: "جست‌وجو",
      show: "نمایش",
      sort: "مرتب‌سازی",
      undo: "لغو",
      unselect: "عدم انتخاب",
      expand: "باز کن",
      close: "ببند",
      close_menu: "بستن منو",
      open_menu: "باز کردن منو",
    },
    boolean: {
      true: "بله",
      false: "خیر",
      null: "",
    },
    page: {
      create: "ایجاد %{name}",
      dashboard: "داشبورد",
      edit: "%{name} #%{id}",
      error: "مشکلی ایجاد شد",
      list: "لیست %{name}",
      loading: "در حال بارگذاری",
      not_found: "پیدا نشد",
      show: "%{name} #%{id}",
      empty: "هنوز سطری از %{name} وجود ندارد.",
      invite: "آیا میخواهید یک مورد اضافه کنید؟",
    },
    input: {
      file: {
        upload_several:
          "تعدادی فایل برای آپلود دراپ کنید، یا برای انتخاب آن‌ها کلیک کنید.",
        upload_single:
          "فایلی را برای آپلود دراپ کنید، یا برای انتخاب آن کلیک کنید",
      },
      image: {
        upload_several:
          "تعدادی عکس برای آپلود دراپ کنید، یا برای انتخاب آن‌ها کلیک کنید.",
        upload_single:
          "عکسی را برای آپلود دراپ کنید، یا برای انتخاب آن کلیک کنید",
      },
      references: {
        all_missing: "امکان پیدا کردن اطلاعات ارجاعی وجود ندارد.",
        many_missing: "حداقل یکی از مراجع در دسترس نیست.",
        single_missing: "مرجع مورد نظر در دسترس نیست.",
      },
      password: {
        toggle_visible: "پنهان کردن رمز عبور",
        toggle_hidden: "نمایش رمز عبور",
      },
    },
    message: {
      about: "درباره",
      are_you_sure: "آیا اطمینان دارید ؟",
      bulk_delete_content:
        "آیا از حذف  %{name} اطمینان دارید؟ |||| آیا از حدف %{smart_count} عدد از آیتم‌ها اطمینان دارید؟",
      bulk_delete_title:
        "حذف %{name} |||| حذف %{smart_count} عدد از آیتم‌های %{name}",
      delete_content: "آیا از حذف این آیتم اطمینان دارید؟",
      delete_title: "حذف %{name} #%{id}",
      details: "جزییات",
      error: "خطایی در مرورگر رخ داد. درخواست شما کامل نشد",
      invalid_form: "فرم درست پر نشده است. لطفا خطاها را بررسی کنید",
      loading: "صفحه در حال بارگذاری است، چند لحظه صبر کنید",
      no: "خیر",
      not_found:
        "شما یک نشانی اینترنتی اشتباه تایپ کردید یا پیغام بدی را دنبال کردید.",
      yes: "بله",
      unsaved_changes:
        "تغییرات شما ذخیره نشده اند. آیا مطمئن هستید که می خواهید از آنها چشم پوشی کنید؟",
    },
    navigation: {
      no_results: "نتیجه‌ای پیدا نشد",
      no_more_results:
        "شماره صفحه‌ی %{page} خارج از محدوده مجاز است. صفحه قبل را امتحان کنید.",
      page_out_of_boundaries: "شماره صفحه %{page} خارج از محدوده است",
      page_out_from_end: "نمی‌توان به بعد از صفحه آخر رفت",
      page_out_from_begin: "نمی‌توان به قبل از صفحه اول رفت",
      page_range_info: "%{offsetBegin}-%{offsetEnd} (کل: %{total})",
      page_rows_per_page: "تعداد ردیف‌ها در صفحه:",
      next: "بعدی",
      prev: "قبلی",
      skip_nav: "skip_nav"
    },
    auth: {
      auth_check_error: "لطفا برای ادامه وارد شوید",
      user_menu: "پروفایل",
      username: "نام‌کاربری",
      password: "رمز عبور",
      sign_in: "ورود",
      sign_in_error: "شناسایی با شکست مواجه شد، دوباره تلاش کنید",
      logout: "خروج",
    },
    notification: {
      updated: "المان بروز‌رسانی شد",
      created: "المان ایجاد شد",
      deleted: "المان حذف شد",
      bad_item: "المان اشتباه",
      item_doesnt_exist: "المان پیدا نشد",
      http_error: "خطا در برقراری ارتباط با سرور",
      data_provider_error: "خطا در دریافت اطلاعات",
      canceled: "لغو شد",
      logged_out: "نشست کاربری شما به پایان زسیده‌است، لطفا دوباره وصل شوید.",
    },
    validation: {
      required: "اجباری",
      minLength: "حداقل باید %{min} کارکتر باشد",
      maxLength: "باید %{max} کارکتر یا کمتر باشد",
      minValue: "حداقل باید %{min} باشد",
      maxValue: "باید %{max} یا کمتر باشد",
      number: "باید یک عدد باشد",
      email: "باید یک آدرس ایمیل صحیح باشد",
      oneOf: "باید انتخابی از این گزینه‌ها باشد: %{options}",
      regex: "باید با فرمت خاصی هماهنگ باشد (regexp): %{pattern}",
    },
  },
  Luna: {
    general: {
      generic_err: "خطایی رخ داد",
      invalid_phone_number: "شماره‌تلفن صحیح نمی‌باشد",
      send_code: "کد تاییده به شماره‌ی شما پیامک شد",
    },
    menu: {
      marketing: "مارکتینگ",
      users: "کاربران",
      misc: "سایر",
    },
    order: {
      success: "ترتیب تغییر یافت",
      failure: "خطایی در تغییر ترتیب رخ داد!",
    },
  },
  red: {
    user: {HIGH: "oio"},
  },
  resources: {
    adminUsers: {
      name: "مدیران",
      fields: {
        name: "نام",
        phoneNumber: "شماره",
        role: "دسترسی",
      },
    },
    advice: {
      name: "توصیه‌ها",
      fields: {
        type: "نوع",
        title: "عنوان توصیه",
        text: "محتوا",
        urlTitle: "عنوان دکمه ی call to action ",
        url: "لینک call to action",
        bannerImage: "عکس بنر",
        updatedAt: "بروز شده",
        isPin: "پین شده",
        isDaily: "روزانه",
        version: "نسخه",
        isAdvertise: "تبلیغ",
        isHidden: "مخفی",
        expirationDate: "تاریخ انقضا",
        createdAt: "ایجاد شده",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت‌ها",
        objectId: "شناسه",
        typeName: "نوع",
      },
    },
    termsCondition: {
      name: "قوانین",
      fields: {
        text: "محتوا",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت‌ها",
        objectId: "شناسه",
        typeName: "نوع",
      },
    },
    codes: {
      name: "کدهای ورود",
      fields: {
        phoneNumber: "شماره تلفن",
        code: "کدهای ورود",
        createdAt: "ایجاد شده",
        objectId: "شناسه",
      },
    },
    blogCategory: {
      name: "دسته بلاگ",
      fields: {
        icon: "تصویر",
        objectId: "شناسه",
        title: "عنوان",
        order: "ترتیب",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت ها",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    forumCategory: {
      name: "دسته فروم",
      fields: {
        icon: "تصویر",
        objectId: "شناسه",
        title: "عنوان",
        description: "توضیحات",
        isPremium: "اشتراکی",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت‌ها",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    blog: {
      name: "بلاگ",
      fields: {
        blogCategory: "دسته بلاگ",
        blogCategoryId: "شناسه دسته بلاگ",
        icon: "تصویر",
        description: "توضیحات",
        isPremium: "اشتراکی",
        referenceUrl: "آدرس مرجع",
        objectId: "شناسه",
        title: "عنوان",
        order: "ترتیب",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت‌ها",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    marketLogin: {
      name: "لاگین مارکت",
      fields: {
        market: "مارکت",
        loginTypes: "نوع لاگین",
        objectId: "شناسه",
        adminLoginTypes: "نوع لاگین",
        adminLoginTypesShow: "نوع لاگین",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    forum: {
      name: "فروم",
      fields: {
        blogCategory: "دسته فروم",
        blogCategoryId: "شناسه دسته فروم",
        icon: "تصویر",
        description: "توضیحات",
        conversationId: "شناسه مکالمه",
        conversationUrl: "آدرس مکالمه",
        isPremium: "اشتراکی",
        isDisabled: "غیر فعال",
        objectId: "شناسه",
        title: "عنوان",
        userCount: "تعداد کاربران عضو شده",
        specialistUserCount: "تعداد متخصصان",
        messageCount: "تعداد کل ‌پیام‌ها‌",
        specialistMessageCount: "تعداد ‌پیام‌ها‌ی متخصصان",
        voiceCount: "تعداد پیام های صوتی",
        imageCount: "تعداد تصاویر",
        replyCount: "تعداد ریپلای ها",
        ageLimit: "محدودیت سنی",
        usersWithAtLeastOneMessageCount: "تعداد کاربران با حداقل 1 پیام",
        adsActive: "فعال بودن تبلیغ",
        adsButtonTitle: "عنوان دکمه تبلیغ",
        adsTitle: "عنوان تبلیغ",
        adsSolidColor: "رنگ پس زمینه تبلیغ",
        adsGradiantColor: "گرادیانت پس زمینه تبلیغ",
        adsGradiantColorShow: "گرادیانت پس زمینه تبلیغ",
        adsVersion: "ورژن تبلیغ",
        isAdPublic: "تبلیغ همگانی؟",
        link: "لینک",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت‌ها",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    conversationAd: {
      name: "تبلیغات دورهمی",
      fields: {
        imageUrl: "آدرس عکس",
        description: "توضیحات",
        backgroundColor: "رنگ پس زمینه",
        backgroundImageUrl: "آدرس عکس پس زمینه",
        link: "لینک",
        expirationDate: "تاریخ انقضا",
        objectId: "شناسه",
        title: "عنوان",
        order: "ترتیب",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت‌ها",
        updatedAt: "بروز شده",
        createdAt: "ایجاد شده",
      },
    },
    user: {
      name: "کاربر",
      fields: {
        name: "نام",
        objectId: "شناسه",
        updatedAt: "بروز شده",
        phoneNumber: "شماره تلفن",
        email: "ایمیل",
        registeredDate: "ثبت نام",
        signupCompleted: "ثبت نام تکمیل شده",
        isBlocked: "بلاک شده",
        weight: "وزن",
        averagePeriodLength: "میانگین طول پریود",
        averageCycleLength: "میانگین طول دوره پریود",
        averagePredictedCycleLength: "میانگین طول دوره حساب شده پریود",
        irregularityStartDay: "شروع پریود نامنظم",
        irregularityEndDay: "پایان پریود نامنظم",
        averageIrregularityCycleLength: "میانگین طول پریود نامنظم",
        lastPeriodStartDate: "تاریخ شروع آخرین پریود",
        lastPeriodEndDate: "تاریخ پایان آخرین پریود",
        minimumCycleLength: "کوتاه ترین طول دوره پریود",
        maximumCycleLength: "بلند ترین طول دوره پریود",
        firstNextPeriodStartDate: "تاریخ پیش بینی دوره پریود بعدی",
        nearestPeriodOvulation: "تاریخ پیش‌ بینی دوره تخمک‌ گذاری بعدی",
        numberOfPeriods: "تعداد پریودهای ثبت شده",
        market: "مارکت",
        category: "دسته بندی",
        adminSpecialistCategories: "دسته بندی متخصص",
        sex: "جنسیت",
        userGoal: "هدف کاربر",
        deviceInfo: "اطلاعات گوشی کاربر",
        Role: "دسترسی",
        specialistBusy: "مشغول بودن متخصص",
        specialistActive: "فعال بودن متخصص",
        specialistExperienceYear: "مدت زمان تجربه متخصص",
        medicalNumber: "شماره نظام پزشکی",
        specialistPriorityOrder: "الویت متخصص",
        description: "توضیحات",
        avatarUrl: "آدرس عکس پروفایل",
        invoice: "خریدها",
        price: "مبلغ(ریال)",
        completed: "کامل شده",
        title: "عنوان",
        status: "وضعیت",
        sku: "sku",
        createdAt: "ایجاد شده",
        refundedToCash: "بازگشت وجه به حساب بانکی",
        refundedToWallet: "بازگشت وجه به کیف پول",
        gateway: "درگاه",
        walletBalance: "موجودی کیف پول (ریال)",
        birthdate: "تاریخ تولد"
      },
    },
    config: {
      name: "کانفیگ",
      fields: {
        type: "نوع",
        value: "مقدار",
        id: "شناسه",
        updatedAt: "بروز شده",
      },
    },
    avatar: {
      name: "آواتارها",
      fields: {
        objectId: "شناسه",
        name: "نام",
        avatarUrl: "آدرس آواتار",
        active: "فعال",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },
    periods: {
      name: "پریود",
      fields: {
        objectId: "شناسه",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
        startDate: "تاریخ شروع",
        endDate: "تاریخ پایان",
        note: "یادداشت",
        userId: "شناسه کاربر",
      },
    },
    report: {
      name: "گزارش‌ها",
      fields: {
        objectId: "شناسه",
        reporterUserId: "شناسه گزارشگر",
        reportType: "نوع گزارش",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
        reportStatus: "حالت گزارش",
        reportedUserId: "شناسه کاربر گزارش شده",
        conversationId: "شناسه مکالمه گزارش شده",
        messageId: "شناسه پیام گزارش شده",
        conversationUrl: "آدرس مکالمه",
        messageUrl: "آدرس پیام"
      },
    },
    adminLogHistory: {
      name: "تاریخچه فعالیت",
      fields: {
        objectId: "شناسه",
        logType: "نوع",
        action: "عملیات",
        createdAt: "ایجاد شده",
        phoneNumber: "شماره تلفن",
        userId: "شناسه کاربر",
        name: "نام",
        previousData: "قبل ویرایش",
        nextData: "بعد ویرایش",
      },
    },
    specialistCard: {
      name: "پلن متخصصان",
      fields: {
        objectId: "شناسه",
        specialistUserId: "شناسه متخصص",
        price: "مبلغ(ریال)",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
        sku: "sku",
        title: "عنوان",
        active: "فعال",
        description: "توضیحات",
      },
    },
    specialistComment: {
      name: "پلن متخصصان",
      fields: {
        objectId: "شناسه",
        specialistUserId: "شناسه متخصص",
        userId: "کاربر",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
        recommendedSpecialist: "متخصص توصیه شده؟",
        rate: "امتیاز",
        text: "متن",
        visible: "قابل مشاهده",
        conversationId: "مکالمه",
      },
    },
    specialistTransaction: {
      name: "مراجعه ها",
      fields: {
        objectId: "شناسه",
        specialistUserId: "شناسه متخصص",
        userId: "کاربر",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
        invoiceId: "پرداخت",
        closed: "بسته شده",
        totalMessage: "تعداد پیام ها",
        countUserMessage: "تعداد پیام های دکتر",
        conversationId: "مکالمه",
      },
    },
    invoice: {
      name: "خرید‌ها",
      fields: {
        objectId: "شناسه",
        title: "عنوان",
        phoneNumber: "شماره‌تلفن",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
        email: "ایمیل",
        price: "مبلغ(ریال)",
        sku: "sku",
        userId: "شناسه کاربر",
        type: "نوع",
        gateway: "درگاه",
        statusName: "وضعیت",
        typeName: "نوع",
        gatewayName: "درگاه",
        market: "مارکت",
        gatewayData: "اطلاعات درگاه",
        completed: "کامل شده",
        status: "وضعیت",
        text: "متن",
        conversationClosedDate: "تاریخ بسته شدن مکالمه",
        firstUserMessageDate: "تاریخ اولین پیام کاربر",
        lastTenMessages: "10 پیام اخیر",
        refundedToWallet: "بازگشت وجه به کیف پول",
        refundedToCash: "بازگشت وجه به حساب بانکی",
        gatewayDataName: "اطلاعات درگاه"
      },
    },
    message: {
      name: "پیام ها",
      fields: {
        objectId: "شناسه",
        conversationId: "شناسه مکالمه",
        text: "متن",
        senderUserId: "شناسه کاربر فرستنده",
        seenByUsersId: "شناسه کاربران دیده",
        attachmentId: "شناسه پیوست",
        isDeleted: " حذف شده؟",
        messageHistory: " تاریخچه پیام",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },
    attachment: {
      name: "پیوست ها",
      fields: {
        objectId: "شناسه",
        url: "آدرس",
        fileType: "نوع فایل",
        fileSize: "حجم فایل",
        fileName: "نام فایل",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },
    userConversation: {
      name: "کاربران مکالمه",
      fields: {
        objectId: "شناسه",
        userId: "شناسه کاربر",
        conversationId: "شناسه مکالمه",
        userConditions: "وضعیت های کاربر",
        conditions: "وضعیت ها",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },
    plan: {
      name: "پلن‌ها",
      fields: {
        objectId: "شناسه",
        sku: "sku",
        price: "مبلغ",
        planTypeId: "نوع پلن",
        title: "عنوان",
        description: "توضیحات",
        duration: "مدت",
        isDeleted: "حذف شده؟",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    planType: {
      name: "نوع پلن‌ها",
      fields: {
        objectId: "شناسه",
        name: "نام",
        title: "عنوان",
        description: "توضیحات",
        features: "ویژگی‌ها",
        isDeleted: "حذف شده؟",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    promotion: {
      name: "پروموشن",
      fields: {
        objectId: "شناسه",
        title: "عنوان",
        description: "توضیحات",
        startDate: "تاریخ شروع",
        endDate: "تاریخ پایان",
        percent: "درصد",
        plansId: "پلن‌ها",
        specialistIds: "متخصص ها",
        clinicCategories: "دسته پزشکان",
        specialistCardIds: "پلن دکتران",
        adminPlansId: "پلن‌ها",
        adminSpecialistIds: "متخصص ها",
        adminClinicCategories: "دسته پزشکان",
        adminSpecialistCardIds: "پلن دکتران",
        isDeleted: "حذف شده؟",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    eventBanner: {
      name: "بنر رویداد",
      fields: {
        objectId: "شناسه",
        title: "عنوان",
        image: "عکس مربوطه",
        callToAction: "callToAction",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    planFeatures: {
      name: "ویژگی‌های پلن",
      fields: {
        objectId: "شناسه",
        title: "عنوان",
        description: "توضیحات",
        isDeleted: "حذف شده؟",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    discount: {
      name: "پروموشن",
      fields: {
        objectId: "شناسه",
        code: "کد",
        percent: "درصد",
        limit: "ظرفیت",
        description: "توضیحات",
        consumed: "مصرف شده",
        type: "نوع",
        typeName: "نوع",
        bulkDiscountId: "کدتخفیف انبوه",
        expirationDate: "تاریخ انقضا",
        specialistIds: "متخصص ها",
        clinicCategories: "دسته پزشکان",
        specialistCardIds: "پلن دکتران",
        adminPlansId: "پلن‌ها",
        plansId: "پلن‌ها",
        adminSpecialistIds: "متخصص ها",
        adminClinicCategories: "دسته پزشکان",
        adminSpecialistCardIds: "پلن دکتران",
        isDeleted: "حذف شده؟",
        clinic: "کلینیک",
        subscription: "سابسکریپشن",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    subscription: {
      name: "سابسکریپشن",
      fields: {
        objectId: "شناسه",
        userId: "شناسه کاربر",
        expirationDate: "تاریخ انقضا",
        planTypeId: "نوع پلن",
        isDeleted: "حذف شده؟",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    bulkDiscount: {
      name: "کدتخفیف انبوه",
      fields: {
        objectId: "شناسه",
        percent: "درصد",
        count: "تعداد",
        limit: "ظرفیت",
        description: "توضیحات",
        consumed: "مصرف شده",
        type: "نوع",
        typeName: "نوع",
        expirationDate: "تاریخ انقضا",
        prefix: "پیشوند",
        specialistIds: "متخصص ها",
        clinicCategories: "دسته پزشکان",
        specialistCardIds: "پلن دکتران",
        adminPlansId: "پلن‌ها",
        adminSpecialistIds: "متخصص ها",
        adminClinicCategories: "دسته پزشکان",
        adminSpecialistCardIds: "پلن دکتران",
        isDeleted: "حذف شده؟",
        clinic: "کلینیک",
        subscription: "سابسکریپشن",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },

    conversation: {
      name: "مکالمه ها",
      fields: {
        objectId: "شناسه",
        usersId: "شناسه های کاربران",
        adminsId: "شناسه های ادمین ها",
        hiddenUsersId: "شناسه های کاربران مخفی",
        status: "وضعیت",
        conversationStatusName: "وضعیت",
        type: "نوع",
        disabledUsersId: "شناسه کاربران غیرمجاز",
        products: "محصول",
        isDeleted: "حذف شده",
        title: "عنوان",
        description: "توضیحات",
        tag: "تگ ها",
        rate: "امتیاز",
        lastMessageDate: "تاریخ آخرین پیام",
        messageCount: "تعداد پیام ها",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
        adminProducts: "محصولات",
        adminTag: "تگ ها"
      }
    },
    experiment: {
      name: "آزمایش ها", fields: {
        objectId: "شناسه",
        title: "عنوان",
        minAppVersion: "کم ترین ورژن ",
        isActive: "فعال",
        startDate: "تاریخ شروع",
        description: "توضیحات",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      }
    }, variant: {
      name: "متغییر ها", fields: {
        objectId: "شناسه",
        title: "عنوان",
        weight: "وزن",
        isActive: "فعال",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      }
    }, userVariant: {
      name: "متغییر ها و کاربران", fields: {
        objectId: "شناسه",
        title: "عنوان",
        weight: "وزن",
        isActive: "فعال",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      }
    }, childWeek: {
      name: "مدیریت هفته های جنین", fields: {
        weekNumber: "شماره هفته",
        height: "قد",
        weight: "وزن",
        description: "توضیحات",
        additionalDescription: "توضیحات اضافه",
        imageUrl: "لینک عکس",
        image: "عکس",
        markets: "مارکت‌ها",
        adminMarkets: "مارکت‌ها",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },welcomeModal: {
      name: "مودال خوش آمدید", fields: {
        version: "ورژن",
        deepLink: "دیپ لینک",
        imageLink: "لینک عکس",
        text: "توضیحات",
        createdAt: "ایجاد شده",
        updatedAt: "بروز شده",
      },
    },
  },
};
